import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import { getEnvironment, isLocalhost } from 'src/services/http/user';

import { getAnalyticsAnonymousId } from './initializeFeatureGates';

export const initializeSentry = () => {
  Sentry.init({
    release: (document.querySelector('meta[name="version"]') as HTMLMetaElement | null)?.content,
    environment: isLocalhost() ? 'e2e' : getEnvironment(),
    dsn: process.env.SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
  });

  Sentry.setUser({ id: getAnalyticsAnonymousId() });
};
